import { Translator } from 'Translator';
import React, { useMemo } from 'react';
import SelectMenuItem from '~/reusable-components/navigation/NavigationMenuList/SelectMenuItem';
import { useI18n } from '~/stores/i18n';
import { getLanguageList } from '~/utils/i18n';

function LanguageMenuItem() {
  const { lang } = useI18n();
  const languages = useMemo(() => getLanguageList(), []);
  const selectedLanguage = lang;
  const onLanguageChange = (newValue: string) =>
    Translator.setLanguageCode(newValue);

  const options = languages.map((language) => ({
    label: language.name,
    value: language.code,
  }));

  return (
    <SelectMenuItem
      selectedItem={selectedLanguage}
      options={options}
      onSelect={onLanguageChange}
      label="Language"
    />
  );
}

export default LanguageMenuItem;
